import { useTranslation } from 'react-i18next';
import { IconButton, Button, Divider } from '@mui/material';

import { NotifyIcon, NotifyTypo } from 'web-components';

import { ReactComponent as CreateSupportTicketIcon } from 'attrs/images/create_support_ticket.svg';

import { DesktopContentWrapper, CreateTicketWrapper, ContactsWrapper, ContactItem } from './DesktopContent.styled';

export interface SupportModalContentProps {
  data: {
    'e-mail': string;
    enabled_config: {
      batch: boolean;
      data_exports: boolean;
    };
    features: Array<{
      enabled: boolean;
      feature: {
        constant: string;
        enabled: boolean;
        id: string;
        name: string;
        translation: Array<{
          country: string;
          translate: string;
        }>;
      };
      feature_id: string;
      id: string;
      organization_id: string;
    }>;
    id: string;
    is_disabled: boolean;
    logo: string;
    name: string;
    phone: string;
    url: string;
  };
  copyToClipboard(arg0: string, arg1: string): void;
  createTicket: () => void;
}

interface DesktopContentProps extends SupportModalContentProps {
  copyToClipboard(arg0: string, arg1: string): void;
}

const DesktopContent = ({ data, copyToClipboard, createTicket }: DesktopContentProps) => {
  const { t } = useTranslation();

  return (
    <DesktopContentWrapper>
      <CreateTicketWrapper>
        <CreateSupportTicketIcon className="create-ticket" />
        <Button
          variant="contained"
          startIcon={<NotifyIcon iconName="plus" style={{ fontSize: '1.875rem' }} />}
          color="primary"
          size="large"
          onClick={createTicket}
          disableElevation
        >
          {t('support.create_ticket')}
        </Button>
      </CreateTicketWrapper>
      <Divider orientation="vertical" />
      <ContactsWrapper>
        {data['e-mail'] && (
          <div>
            <NotifyTypo.InfoText className="info-text">{t('support.email_us')}</NotifyTypo.InfoText>
            <ContactItem>
              <NotifyIcon iconName="email" />
              <a href={`mailto:${data['e-mail']}`}>{data['e-mail']}</a>
              <IconButton
                className="copy-to-clipboard"
                aria-label="copy-to-clipboard"
                color="inherit"
                onClick={() => copyToClipboard(data['e-mail'], 'email')}
              >
                <NotifyIcon iconName="copy" />
              </IconButton>
            </ContactItem>
          </div>
        )}
        {data.phone && (
          <div>
            <NotifyTypo.InfoText className="info-text">{t('support.call_us')}</NotifyTypo.InfoText>
            <ContactItem>
              <NotifyIcon iconName="phone" />
              <a href={`tel: ${data.phone}`}>{data.phone}</a>
              <IconButton
                className="copy-to-clipboard"
                aria-label="copy-to-clipboard"
                color="inherit"
                onClick={() => copyToClipboard(data.phone, 'phone')}
              >
                <NotifyIcon iconName="copy" />
              </IconButton>
            </ContactItem>
          </div>
        )}
      </ContactsWrapper>
    </DesktopContentWrapper>
  );
};

export default DesktopContent;
